import axios from "axios";
import { useQuery } from "react-query";

export const useGetSentimentTopics = ({ polarity }) => {
  return useQuery(
    ["sentimentTopics", polarity],
    () =>
      axios
        .get("/api/playground/patternInsights/mine", {
          params: { filterSource: "sentiments", filterLevel: "polarity", filterValue: polarity, limit: 500 },
        })
        .then((res) => res.data.chunks || [])
  );
};
